export default {
  namespaced: true,
  state: {
    popupActive: false,
  },
  mutations: {
    OPEN_INVALIDPOPUP(state) {
      state.popupActive = true;
    },
    CLOSE_INVALIDPOPUP(state) {
      state.popupActive = false;
    },
  },
  actions: {
    openInvalidPopup({ commit }, data) {
      commit('OPEN_INVALIDPOPUP', data);
    },
    closeInvalidPopup({ commit }, data) {
      commit('CLOSE_INVALIDPOPUP', data);
    },
  },
};
